import Bugsnag from '@bugsnag/js'

export type BreadcrumbType = 'navigation' | 'process' | 'request' | 'state' | 'user' | 'error' | 'log';

export function logError(error: Error, metadata?: Record<string, any>) {
    try {
        if (metadata) {
            Bugsnag.addMetadata('errorContext', metadata);
        }
        Bugsnag.notify(error);
    } catch (bugsnagError) {
        // Silently fail if Bugsnag is not properly initialized or user is not set
        console.warn('Failed to log error to Bugsnag:', bugsnagError);
    }
}

export function logMessage(message: string, metadata?: Record<string, any>) {
    try {
        const error = new Error(message);
        if (metadata) {
            Bugsnag.addMetadata('context', metadata);
        }
        Bugsnag.notify(error);
    } catch (bugsnagError) {
        // Silently fail if Bugsnag is not properly initialized or user is not set
        console.warn('Failed to log message to Bugsnag:', bugsnagError);
    }
}

export function leaveBreadcrumb(message: string, metadata?: Record<string, any>, type?: BreadcrumbType) {
    try {
        Bugsnag.leaveBreadcrumb(message, metadata, type || 'log');
    } catch (bugsnagError) {
        // Silently fail if Bugsnag is not properly initialized
        console.warn('Failed to leave breadcrumb in Bugsnag:', bugsnagError);
    }
}

export function setUser(userId: string, email?: string, name?: string) {
    try {
        Bugsnag.setUser(userId, email, name);
    } catch (bugsnagError) {
        // Silently fail if Bugsnag is not properly initialized
        console.warn('Failed to set user in Bugsnag:', bugsnagError);
    }
}

export function addMetadata(section: string, data: Record<string, any>) {
    try {
        Bugsnag.addMetadata(section, data);
    } catch (bugsnagError) {
        // Silently fail if Bugsnag is not properly initialized
        console.warn('Failed to add metadata to Bugsnag:', bugsnagError);
    }
}

export function clearMetadata(section: string, key?: string) {
    try {
        Bugsnag.clearMetadata(section, key);
    } catch (bugsnagError) {
        // Silently fail if Bugsnag is not properly initialized
        console.warn('Failed to clear metadata in Bugsnag:', bugsnagError);
    }
}